import axios from 'axios'

export const encrypt = async (text: string) => {
    try {
        const { data } = await axios.post('/api/encrypt', { text })
        return data.encryptedText as string
    } catch (error) {
        console.error('Encryption failed:', error)
    }
}

export const decrypt = async (cipherText: string) => {
    try {
        const { data } = await axios.post('/api/decrypt', { cipherText })
        return data.decryptedText as string
    } catch (error) {
        console.error('Decryption failed:', error)
    }
}